type Route = {
  path: string;
  breadcrumb: string;
  title: string;
};

const routes: Route[] = [
  { path: '/', breadcrumb: 'Dashboard', title: 'Dashboard' },
  { path: '/timesheets', breadcrumb: 'Timesheets', title: 'Timesheets' },
  { path: '/timesheets/:id', breadcrumb: 'Edit', title: 'Edit Timesheet' },
  { path: '/admin/timesheetSearch', breadcrumb: 'Timesheet Search', title: 'Timesheet Search' },
  { path: '/admin/timesheetSearch/:id', breadcrumb: 'View', title: 'Timesheet Search View' },
  { path: '/my-profile', breadcrumb: 'My Profile', title: 'My Profile' },
  {
    path: '/change-password',
    breadcrumb: 'Change Password',
    title: 'Change Password',
  },

  //Proofing
  {
    path: '/proofing',
    breadcrumb: 'Timesheet Proofing',
    title: 'Timesheet Proofing',
  },
  {
    path: '/proofing/week/:id',
    breadcrumb: 'Week',
    title: 'Timesheet Proofing Week',
  },
  {
    path: '/proofing/summary',
    breadcrumb: 'Timesheet Summary',
    title: 'Timesheet Summary',
  },
  {
    path: '/proofing/transfer',
    breadcrumb: 'TimeEntry Transfer',
    title: 'TimeEntry Transfer',
  },

  //Accounting
  {
    path: '/accounting/invoice',
    breadcrumb: 'Invoice',
    title: 'Invoice Review',
  },
  {
    path: '/accounting/invoice/draft',
    breadcrumb: 'Draft',
    title: 'Invoice Draft Preview',
  },  
  { 
    path: '/accounting/invoice/detail',
    breadcrumb: 'Detail',
    title: 'Invoice Detail Report'
  },
  { 
    path: '/accounting/invoice/summary',
    breadcrumb: 'Summary',
    title: 'Invoice Summary Report'
  },
  { 
    path: '/accounting/invoice/exports',
    breadcrumb: 'Exports',
    title: 'Invoice Exports'
  },
  { 
    path: '/accounting/invoice/exports/detail',
    breadcrumb: 'Detail',
    title: 'Invoice Exports Detail'
  },
  { 
    path: '/accounting/invoice/exports/edit',
    breadcrumb: 'Edit',
    title: 'Edit Invoice Exports'
  },
  { 
    path: '/accounting/bill', 
    breadcrumb: 'Bill Creator', 
    title: 'Bill Creator'
  },
  { 
    path: '/accounting/bill/exports', 
    breadcrumb: 'Bill Exports', 
    title: 'Bill Exports'
  },
  { 
    path: '/accounting/bill/exports/details/:id', 
    breadcrumb: 'Bill Export Details', 
    title: 'Bill Export Details'
    },
  //Caseloads
  { path: '/caseload', breadcrumb: 'Caseloads', title: 'Caseloads' },
  { path: '/caseloads', breadcrumb: 'Caseloads', title: 'Caseloads' },
  { path: '/caseload/approve', breadcrumb: 'Approve', title: 'Approve' },
  { path: '/caseload/duplicates', breadcrumb: 'Student Merge', title: 'Student Merge' },
  { path: '/caseload/search', breadcrumb: 'Search', title: 'Search' },
  {
    path: '/caseloadTransfer',
    breadcrumb: 'Caseload Transfer',
    title: 'Caseload Transfer',
  },
  {
    path: '/caseload/searchCaseloads',
    breadcrumb: 'Caseload Search',
    title: 'Caseload Search',
  },
  {
    path: '/caseloadTransfer/transfer',
    breadcrumb: 'Select Therapist',
    title: 'Select Therapist',
  },
  { path: '/messages', breadcrumb: 'Messaging', title: 'Messaging' },

  //Reports
  { path: '/reports', breadcrumb: 'Reports', title: 'Reports' },
  { path: '/reports/powerbi', breadcrumb: 'PowerBI', title: 'PowerBI' },
  { path: '/reports/powerbi/:id', breadcrumb: 'PowerBI', title: 'PowerBI' },

  { path: '/reportbug', breadcrumb: 'Report Bug', title: 'Report Bug' },

  //Account/Passwords
  { path: '/account', breadcrumb: 'My Account', title: 'My Account' },
  { path: '/Login', breadcrumb: 'Log In', title: 'Log In' },
  {
    path: '/forgot-password',
    breadcrumb: 'Forgot Password',
    title: 'Forgot Password',
  },
  {
    path: '/reset-password',
    breadcrumb: 'Reset Password',
    title: 'Reset Password',
  },
  {
    path: '/forced-change-password',
    breadcrumb: 'Forced Change Password',
    title: 'Forced Change Password',
  },

  //Discipline Groups
  {
    path: '/admin/disciplines/groups',
    breadcrumb: 'Groups',
    title: 'Discipline Groups',
  },
  {
    path: '/admin/disciplines/groups/new',
    breadcrumb: 'Create',
    title: 'Create Discipline Group',
  },
  {
    path: '/admin/disciplines/groups/:id',
    breadcrumb: 'Edit',
    title: 'Edit Discipline Group',
  },

  //Disciplines
  {
    path: '/admin/disciplines',
    breadcrumb: 'Disciplines',
    title: 'Disciplines',
  },
  {
    path: '/admin/disciplines/new',
    breadcrumb: 'Create',
    title: 'Create Discipline',
  },
  {
    path: '/admin/disciplines/:id',
    breadcrumb: 'Edit',
    title: 'Edit Discipline',
  },
  
  //Divisions
  {
    path: '/admin/divisions',
    breadcrumb: 'Divisions',
    title: 'Divisions',
  },
  {
    path: '/admin/divisions/new',
    breadcrumb: 'Create',
    title: 'Create Division',
  },
  {
    path: '/admin/divisions/:id',
    breadcrumb: 'Edit',
    title: 'Edit Division',
  },

  //Home Districts
  {
    path: '/admin/homeDistricts',
    breadcrumb: 'Home Districts',
    title: 'Home Districts',
  },
  {
    path: '/admin/homeDistricts/new',
    breadcrumb: 'Create',
    title: 'Create Home District',
  },
  {
    path: '/admin/homeDistricts/:id',
    breadcrumb: 'Edit',
    title: 'Edit Home District',
  },

  //Notification
  {
    path: '/admin/notifications',
    breadcrumb: 'Notifications',
    title: 'Notifications',
  },
  {
    path: '/admin/notifications/new',
    breadcrumb: 'New',
    title: 'New Notification',
  },
  {
    path: '/admin/notifications/:id',
    breadcrumb: 'Edit',
    title: 'Edit Notification',
  },

  //Therapists
  {
    path: '/admin/therapists',
    breadcrumb: 'Therapists',
    title: 'Therapists',
  },
  {
    path: '/admin/therapists/approve',
    breadcrumb: 'Approve Changes',
    title: 'Approve Changes',
  },
  {
    path: '/admin/therapists/unlockTimesheets',
    breadcrumb: 'Unlock Timeshet Requests',
    title: 'Unlock Timeshet Requests',
  },
  {
    path: '/admin/therapists/:id',
    breadcrumb: 'Edit',
    title: 'Edit Therapist',
  },

  //Task Types
  {
    path: '/admin/task-types',
    breadcrumb: 'Task Types',
    title: 'Task Types',
  },
  {
    path: '/admin/task-types/new',
    breadcrumb: 'Create',
    title: 'Create Task Type',
  },
  {
    path: '/admin/task-types/:id',
    breadcrumb: 'Edit',
    title: 'Edit Task Type',
  },

  //ESYs
  {
    path: '/admin/esys',
    breadcrumb: 'ESYs',
    title: 'ESYs',
  },
  {
    path: '/admin/esys/new',
    breadcrumb: 'Create',
    title: 'Create ESY',
  },
  {
    path: '/admin/esys/:id',
    breadcrumb: 'Edit',
    title: 'Edit ESY',
  },

  //Placements
  {
    path: '/admin/placements',
    breadcrumb: 'Placements',
    title: 'Placements',
  },
  {
    path: '/admin/placements/new',
    breadcrumb: 'Create',
    title: 'Create Placement',
  },
  {
    path: '/admin/placements/:id',
    breadcrumb: 'Edit',
    title: 'Edit Placement',
  },

  //Users
  {
    path: '/admin/users',
    breadcrumb: 'Users',
    title: 'Users',
  },
  {
    path: '/admin/users/new',
    breadcrumb: 'Create',
    title: 'Create User',
  },
  {
    path: '/admin/users/:id',
    breadcrumb: 'Edit',
    title: 'Edit User',
  },

  //Districts
  {
    path: '/admin/districts/:districtId/schools/new',
    breadcrumb: 'Create',
    title: 'Create School',
  },
  {
    path: '/admin/districts/:districtId/schools/:id',
    breadcrumb: 'Edit',
    title: 'Edit School',
  },
  {
    path: '/admin/districts/:districtId/rates/new',
    breadcrumb: 'Create',
    title: 'Create Rate',
  },
  {
    path: '/admin/districts/rates/approve',
    breadcrumb: 'Approve',
    title: 'Approve Rates',
  },
  {
    path: '/admin/districts/:districtId/rates/:id',
    breadcrumb: 'Edit',
    title: 'Edit Rate',
  },
  {
    path: '/admin/districts',
    breadcrumb: 'Districts',
    title: 'Districts',
  },
  {
    path: '/admin/districts/new',
    breadcrumb: 'Create',
    title: 'Create District',
  },
  {
    path: '/admin/districts/:id',
    breadcrumb: 'Edit',
    title: 'Edit District',
  },
  // Discipline Group Rules
  {
    path: '/admin/disciplineGroupRules',
    breadcrumb: 'Treatment Type Rules by Discipline Group',
    title: 'Treatment Type Rules by Discipline Group',
  },

  {
    path: '/caseloads',
    breadcrumb: 'Caseloads',
    title: 'Caseloads',
  },
  {
    path: '/caseload/searchCaseloads',
    breadcrumb: 'Caseload Search',
    title: 'Caseload Search',
  },
  {
    path: '/messages',
    breadcrumb: 'Messages',
    title: 'Disciplines',
  },
  {
    path: '/messages/:id',
    breadcrumb: 'Thread',
    title: 'Thread',
  },
   {
    path: '/caseload/manualmerge',
    breadcrumb: 'Manual Merge',
    title: 'Manual Merge',
  },
];

export default routes;
